<basic-input
  [control]="control"
  [icon]="icon"
  [label]="label"
  [id]="id"
  [iconType]="iconType"
  [placeholder]="placeholder"
  [isLoading]="isLoading"
  [required]="required"
  [fieldType]="basicFieldType"
  [prefixSlug]="urlPrefix"
  (onBlurValueChange)="onBlurEvent($event)"
  (onKeydown)="onKeydownEvent($event)"
  [mode]="mode"
  [allowClearButton]="allowClearButton"
></basic-input>
